import Connector from './prototype';

const connector = new Connector();

window.callbacks = {
  getUserCallback: (params) => {
    connector.getUser = () => JSON.parse(params);
  },
  getDeviceCallback: (params) => {
    // connector.getDevice = () => JSON.parse(params);
    connector.getDevice = () => params;
  },
};

window.getUrlCallback = (params) => {
  connector.getUrls = () => params;
};
// window.webkit.messageHandlers.getUser.postMessage(
//   JSON.stringify({ callback: 'window.callbacks.getUserCallback' }),
// );

connector.callExit = () => {
  window.webkit.messageHandlers.callExit.postMessage('');
};

connector.getUrlCallbackFn = () => {
  window.webkit.messageHandlers.getTermsConfiguration.postMessage(
    JSON.stringify({ callback: 'window.getUrlCallback' }),
  );
};


window.getUserCallback = (params) => {
  connector.getUser = () => params;
};

// 获取删除账号信息
connector.getIOSInfoFn = () => {
  const obj = {
    action: 10,
    data: {
      function: 'delAccount',
      callback: 'getDelInfo', // 参数回调的方法
    },
  };
  window.location.href = `unionMessage://${window.btoa(JSON.stringify(obj))}`;
};
// 传递优惠券码
connector.onPayUiShow = () => {};
window.getDelInfo = (params) => {
  connector.getDelInfo = () => params;
};
// connector.onEvent = (event, params) => {
//   window.webkit.messageHandlers.onEvent.postMessage(
//     JSON.stringify({ event, params }),
//   );
// };

connector.changePassword = (jsonStr) => {
  window.webkit.messageHandlers.changePassword.postMessage(jsonStr);
};

connector.postMessage = (msg) => {
  window.location.href = `unionMessage://${window.btoa(
    encodeURIComponent(JSON.stringify(msg)),
  )}`;
};

// window.webkit.messageHandlers.getDevice.postMessage(
//   JSON.stringify({ callback: 'window.callbacks.getDeviceCallback' }),
// );

// window.webkit.messageHandlers.hello.postMessage(
//   JSON.stringify({ callback: 'window.callbacks.getHelloCallback' }),
// );
export default connector;



// WEBPACK FOOTER //
// ./src/common/js/native/ios.js